export default "__VITE_ASSET__D_A852U6__"